import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-6 grid-cols-5" }
const _hoisted_2 = { class: "flex flex-row justify-between border-t" }
const _hoisted_3 = { class: "flex flex-row py-4" }
const _hoisted_4 = { class: "mt-2 text-red-lp-100 font-semibold" }
const _hoisted_5 = { class: "text-red-lp-100 mt-2 font-semibold" }
const _hoisted_6 = { class: "text-red-lp-100 mt-2 font-semibold" }
const _hoisted_7 = { class: "text-red-lp-100 mt-2 font-semibold" }
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalInstantBoookingConfirmation = _resolveComponent("ModalInstantBoookingConfirmation")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.$t('instantBooking.title'),
      "vertical-separator": false,
      "is-floating-action": false,
      fullPage: ""
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('instantBooking.form.originCity')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.origin
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-2",
            label: _ctx.$t('instantBooking.form.posName')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.partnerName
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "col-span-4",
            label: _ctx.$t('instantBooking.form.shipmentIdBookingId'),
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                id: "instant_booking_input_shipment_id",
                ref: "inputStt",
                sizeInput: "24px",
                onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addShipmentId())),
                labelStacked: _ctx.$t('instantBooking.form.shipmentIdExample'),
                modelValue: _ctx.form.sourceScaned,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.sourceScaned = $event)),
                  _ctx.onConvertShipment
                ],
                modelModifiers: { trim: true },
                bold: !!_ctx.form.sourceScaned,
                placeholder: _ctx.$t('instantBooking.form.shipmentIdPlaceholder')
              }, null, 8, ["labelStacked", "modelValue", "onUpdate:modelValue", "bold", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _withDirectives(_createVNode("div", null, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('instantBooking.summary.totalShipment'),
                class: "text-12px xxl:text-14px text-black-lp-100"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, _toDisplayString(_ctx.sttListAfterScaned.length), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('instantBooking.summary.totalBookingSuccess'),
                class: "ml-20 text-12px xxl:text-14px text-black-lp-100"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.totalSuccessBook.length), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('instantBooking.summary.totalBookingProgress'),
                class: "ml-20 text-12px xxl:text-14px text-black-lp-100"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.totalProgressBook.length), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('instantBooking.summary.totalBookingFailed'),
                class: "ml-20 text-12px xxl:text-14px text-black-lp-100"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_7, _toDisplayString(_ctx.totalFailedBook.length), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_lp_button, {
                onClick: _cache[3] || (_cache[3] = 
                event => {
                  _ctx.togglePanel(event);
                }
              ),
                title: _ctx.$t('instantBooking.print.receipt'),
                textColor: "white",
                icon: _ctx.panelVisible ? 'chevron-up-white' : 'chevron-down-white'
              }, null, 8, ["title", "icon"]),
              _createVNode(_component_OverlayPanel, {
                ref: "op",
                appendTo: "body",
                style: {"width":"auto"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LpButton, {
                    onClick: _cache[4] || (_cache[4] = 
                  event => {
                    _ctx.printThermal('thermal');
                    _ctx.togglePanel(event);
                    _ctx.trackGTM('instant_print_thermal_pdf_button_clicked');
                  }
                ),
                    class: "w-60",
                    flat: "",
                    dense: "",
                    iconLeft: "printer",
                    title: _ctx.$t('instantBooking.print.thermalPdf'),
                    disabled: !_ctx.isSuccessList
                  }, null, 8, ["title", "disabled"]),
                  _hoisted_9,
                  _createVNode(_component_LpButton, {
                    onClick: _cache[5] || (_cache[5] = 
                  event => {
                    _ctx.printThermal('basic');
                    _ctx.togglePanel(event);
                    _ctx.trackGTM('instant_print_basic_button_clicked');
                  }
                ),
                    class: "w-60",
                    flat: "",
                    dense: "",
                    iconLeft: "printer",
                    title: _ctx.$t('instantBooking.print.basicPdf'),
                    disabled: !_ctx.isSuccessList
                  }, null, 8, ["title", "disabled"]),
                  _hoisted_10,
                  _createVNode(_component_LpButton, {
                    onClick: _cache[6] || (_cache[6] = 
                  event => {
                    _ctx.printInvoice();
                    _ctx.togglePanel(event);
                    _ctx.trackGTM('instant_print_tagihan_button_clicked');
                  }
                ),
                    class: "w-60",
                    flat: "",
                    dense: "",
                    iconLeft: "printer",
                    title: _ctx.$t('instantBooking.print.invoice'),
                    disabled: !_ctx.isSuccessList
                  }, null, 8, ["title", "disabled"])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createVNode(_component_TableV2, {
            columns: _ctx.columns,
            data: _ctx.sttListAfterScaned,
            isRightFreeze: "",
            totalColumnFreeze: 3,
            class: "my-2",
            isPinnedScrollBottom: "",
            borderTop: false,
            buttonAction: ""
          }, null, 8, ["columns", "data"])
        ], 512), [
          [_vShow, _ctx.sttListAfterScaned.length]
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalError,
      title: _ctx.$t('instantBooking.modal.addShipmentFailedTitle'),
      message: _ctx.errorScanShipment,
      image: "circle-error",
      textSuccess: _ctx.$t('instantBooking.modal.back'),
      class: "px-8 create-bagging"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.isError]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('instantBooking.modal.confirmExitTitle'),
      message: _ctx.$t('instantBooking.modal.confirmExitMessage'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('instantBooking.modal.exit'),
      textCancel: _ctx.$t('instantBooking.modal.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isAddTerminated]
    ]),
    _createVNode(_component_ModalInstantBoookingConfirmation, {
      isOpen: _ctx.tncModal,
      onClose: _ctx.onCloseTncModal,
      onAction: _cache[7] || (_cache[7] = 
      () => {
        _ctx.tncModal = false;
      }
    )
    }, null, 8, ["isOpen", "onClose"])
  ], 64))
}